import { useSearchFilters } from '@/hooks/useSearchFilters';
import { SearchPageObjectModel } from '@/poms/searchPageObjectModel';
import { Box, styled } from '@mui/material';
import { MatchTypeSelection } from './MatchTypeSelection';
import { SearchInputSection } from './SearchInputSection';
import { ThresholdSliderSection } from './ThresholdSliderSection';

const SearchControlsContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  height: '100%',
  overflowY: 'auto',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
});

export const SearchControls = () => {
  const {
    selectedFilters,
    isAssetSearch,
    searchType,
    updateSearchQuery,
    searchQuery,
    minThreshold,
    sizeThreshold,
    updateSearchParameters,
  } = useSearchFilters();

  return (
    <SearchControlsContainer sx={{ marginLeft: '6px', marginRight: '6px', width: '250px', flexShrink: 0 }}>
      <SearchInputSection searchQuery={searchQuery} onSearch={updateSearchQuery} />
      {isAssetSearch && <MatchTypeSelection selectedFilters={selectedFilters} />}
      {['geometric', 'part'].includes(searchType) && (
        <ThresholdSliderSection
          label='Match Threshold'
          tooltip='How geometrically similar a part must be to appear.'
          testId={SearchPageObjectModel.MatchToleranceSection}
          value={minThreshold}
          onChange={value => updateSearchParameters({ minThreshold: value })}
        />
      )}
      {['visual'].includes(searchType) && (
        <ThresholdSliderSection
          label='Size Threshold'
          tooltip="How closely a part's size must match to appear."
          testId={SearchPageObjectModel.SizeThresholdSection}
          value={sizeThreshold}
          onChange={value => updateSearchParameters({ sizeThreshold: value })}
        />
      )}
    </SearchControlsContainer>
  );
};
